import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { YMaps } from 'react-yandex-maps';

import Cookies from 'universal-cookie';
import CONFIG from './../SYSTEM/Config.js'

import { Request } from "./../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../REDUX/functions.js';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import HomePage from './../APP/ROUTES/HomePage';
import News from './../APP/ROUTES/News';
import Complaints from './../APP/ROUTES/Complaints';
import Comments from './../APP/ROUTES/Comments';
import Sales from './../APP/ROUTES/Sales';
import Products from './../APP/ROUTES/Products';
import Buh from './../APP/ROUTES/Buh';
import Calendar from './../APP/ROUTES/Calendar';
import Assortment from './../APP/ROUTES/Assortment';
import Orders from './../APP/ROUTES/Orders';
import Order from './../APP/ROUTES/Order';
import Qr from './../APP/ROUTES/Qr';
import Chat from './../APP/ROUTES/Chat';
import PrintMassQr from './../APP/ROUTES/PrintMassQr';
import PrintQr from './../APP/ROUTES/PrintQr';
import CreateOrder from './../APP/ROUTES/CreateOrder'
import Production from './../APP/ROUTES/Production'
import AddProducts from './../APP/ROUTES/AddProducts'

import Marketing from './../APP/ROUTES/Marketing';
import AuthParts from './../APP/COMPONENTS/AuthParts';

import Modals from './../APP/MODALS/Modals';

const cookies = new Cookies();

function mapStateToProps(state, myProps) {
    return {
        USER: state.USER,
        FETCH_UPDATE: state.FETCH_UPDATE,
        FETCH_PENDING_ORDERS: state.FETCH_PENDING_ORDERS,
        SHOW_ELEMENTS: state.SHOW_ELEMENTS,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            LOADED: false
        };

        this.myRef = React.createRef();
        this.periodicTimer = false
    }

    componentDidMount() {
        let COOKIE = cookies.get(CONFIG.COOKIE_TITLE);
        if ((COOKIE !== null) && (typeof COOKIE !== "undefined") && (COOKIE !== "undefined")) {
            this.getAuthByCookie(COOKIE);
        } else {
            this.setState({ LOADED: true });
        }

        this.getPrinterIp()
        this.launchPeriodic()
    }

    getPrinterIp = async () => {
        let printerIp = localStorage.getItem('PRINTER_IP');
        if (printerIp) {
            this.props.setPrinterIp(printerIp)
        }
    }

    launchPeriodic = () => {
        if (this.periodicTimer) {
            clearTimeout(this.periodicTimer)
        }

        this.fetchPendingOrders();
        this.fetchUnreadMessages();

        this.periodicTimer = setTimeout(() => {
            this.launchPeriodic()
        }, 60000)
    }

    getAuthByCookie = async (COOKIE) => {
        try {
            let SEND_DATA = {
                action: 'getSupplierAuthByCookie',
                cookie: COOKIE
            };

            let data = await Request(SEND_DATA, CONFIG.API_GATE);
            if (data !== false) {
                this.props.doAuth(data.supplier);
            }

            let COMPONENT = this;
            setTimeout(function () {
                COMPONENT.setState({ LOADED: true });
            }, 200);
        } catch (error) {
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.USER !== prevProps.USER && this.props.USER && prevProps.USER == false) {
            this.launchPeriodic();
        }
        if (this.props.FETCH_PENDING_ORDERS && this.props.FETCH_PENDING_ORDERS !== prevProps.FETCH_PENDING_ORDERS) {
            this.fetchPendingOrders();
            this.props.fetchPendingOrders(false)
        }
    }

    componentWillUnmount() {
        if (this.periodicTimer) {
            clearTimeout(this.periodicTimer)
        }
    }

    fetchUnreadMessages = async () => {
        try {
            let SEND_DATA = {
                action: 'supplierChatGetUnread',
                supplier_apikey: this.props.USER.supplier_apikey
            };

            let data = await Request(SEND_DATA, CONFIG.API_GATE);
            if (data !== false) {
                this.props.setUnreadMessages(data);
            }
        } catch (error) {

        }
    }

    fetchPendingOrders = async () => {
        if (this.props.USER) {
            if (this.periodicTimer) {
                clearTimeout(this.periodicTimer)
            }

            try {
                let SEND_DATA = {
                    action: 'supplierPendingOrders',
                    supplier_apikey: this.props.USER.supplier_apikey
                };

                let data = await Request(SEND_DATA, CONFIG.API_GATE);
                if (data !== false) {
                    this.props.setPendingOrders(data);
                } else {
                }
            } catch (error) {

            }
        }
    }

    scrollToTop = () => {
        this.myRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    getClassName = () => {
        if (this.props.USER && this.props.SHOW_ELEMENTS) {
            return 'auth_page';
        }

        return '';
    }

    render() {
        if (!this.state.LOADED) {
            return <div></div>
        }

        return (
            <div className={ this.getClassName() } ref={ this.myRef }>
                <AuthParts />
                <Switch>
                    <Route exact path='/' component={ HomePage } />
                    <Route exact path='/assortment' component={ Assortment } />
                    <Route exact path='/news' component={ News } />
                    <Route exact path='/complaints' component={ Complaints } />
                    <Route exact path='/qr' component={ Qr } />
                    <Route exact path='/chat' component={ Chat } />
                    <Route exact path='/print_qr' component={ PrintQr } />
                    <Route exact path='/print_mass_qr' component={ PrintMassQr } />
                    <Route exact path='/comments' component={ Comments } />
                    <Route exact path='/addproducts' component={ AddProducts } />
                    <Route exact path='/orders/:id' component={ Order } />
                    <Route exact path='/orders' component={ Orders } fetchPendingOrders={ this.fetchPendingOrders } />
                    <Route exact path='/sales' component={ Sales } />
                    <Route exact path='/products' component={ Products } />
                    <Route exact path='/buh' component={ Buh } />
                    <Route exact path='/calendar' component={ Calendar } />
                    <Route exact path='/marketing' component={ Marketing } />
                    <Route exact path='/createorder' component={ CreateOrder } />
                    <Route exact path='/production' component={ Production } />
                </Switch>
                <Modals />
            </div>
        );
    }

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App)
